/* Vipejar Site V2 — remove decorative emoji from rendered customer content. */
(() => {
  const emoji = /(?:\p{Regional_Indicator}{2}|[#*0-9]\uFE0F?\u20E3|\p{Extended_Pictographic}(?:\uFE0F|\uFE0E)?(?:\u200D\p{Extended_Pictographic}(?:\uFE0F|\uFE0E)?)*)/gu;
  const symbols = /[↗→➡⬆➜➝➞▶◀★☆✓✔●]/gu;
  const excluded = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'OPTION']);

  const polishCollectionCopy = () => {
    if (!document.body?.classList.contains('template-collection')) return;

    const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
    const intro = document.querySelector('.vp-collection-fallback-intro');
    if (intro) {
      const eyebrow = intro.querySelector(':scope > p');
      const description = intro.querySelector(':scope > h1 + span');
      if (eyebrow) eyebrow.textContent = isEnglish ? 'Vipejar selection' : 'Selección Vipejar';
      if (description) {
        description.textContent = isEnglish
          ? 'Wines available to buy online, with consistent imagery, clear pricing and direct access to purchase.'
          : 'Vinos disponibles para comprar online, con imagen uniforme, precio claro y acceso directo a la compra.';
      }
    }

    const translations = isEnglish
      ? {
          Tinto: 'Red wine',
          Blanco: 'White wine',
          White: 'White wine',
          Rosado: 'Rosé wine',
          Pink: 'Rosé wine',
          Espumoso: 'Sparkling wine',
          Cava: 'Sparkling wine',
        }
      : {
          'Red wine': 'Tinto',
          'White wine': 'Blanco',
          White: 'Blanco',
          'Rosé wine': 'Rosado',
          Pink: 'Rosado',
          'Sparkling wine': 'Espumoso',
        };

    document.querySelectorAll('.product-collection__more-info a, .product-collection__type span, .product-collection__type a').forEach((label) => {
      const current = label.textContent.trim();
      if (translations[current]) label.textContent = translations[current];
    });
  };

  const cleanText = (node) => {
    const parent = node.parentElement;
    if (!parent || excluded.has(parent.tagName) || parent.closest('[contenteditable="true"]')) return;
    const before = node.nodeValue || '';
    const after = before
      .replace(emoji, (match) => (match === '©' || match === '®' || match === '™' ? match : ''))
      .replace(symbols, '')
      ;
    if (after !== before) node.nodeValue = after;
  };

  const clean = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      cleanText(root);
      return;
    }
    if (!(root instanceof Element) && root !== document.body) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    for (let node = walker.nextNode(); node; node = walker.nextNode()) cleanText(node);
  };

  const start = () => {
    polishCollectionCopy();
    clean(document.body);
    new MutationObserver((records) => {
      let collectionContentChanged = false;
      for (const record of records) {
        if (record.type === 'characterData') clean(record.target);
        for (const node of record.addedNodes) {
          clean(node);
          if (node.nodeType === Node.ELEMENT_NODE) collectionContentChanged = true;
        }
      }
      if (collectionContentChanged) polishCollectionCopy();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
